import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateCustomField as CreateCustomFieldMutation,
    CreateCustomFieldVariables as CreateCustomFieldMutationVariables,
} from 'nutshell-graphql-types';

import CREATE_CUSTOM_FIELD from '../mutations/create-custom-field.graphql';

export const useCreateCustomField = (): {
    createCustomField: (arg1: CreateCustomFieldMutationVariables) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [createCustomField, {loading, error}] = useMutation<
        CreateCustomFieldMutation,
        CreateCustomFieldMutationVariables
    >(CREATE_CUSTOM_FIELD);

    return {
        createCustomField: (input: CreateCustomFieldMutationVariables) =>
            createCustomField({variables: input}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
